module.exports = __webpack_public_path__ + "img/logo.d5051ac3.png";